<!--
 * @Author: wangwei
 * @Date: 2021-01-09 10:28:06
 * @LastEditTime: 2021-01-11 15:51:09
 * @LastEditors: Please set LastEditors
 * @Description: 首页开屏图
 * @FilePath: /java-pc/src/components/OpenScreen.vue
-->
<template>
  <div class="sld_open_screen">
      <div class="image">
          <img class="pointer" :src="openScreenData.imgUrl" @click="diyNavTo(openScreenData)" alt="">
      </div>
      <img @click="close" class="close" :src="close_layer_icon" alt="">
  </div>
</template>

<script>
import {getCurrentInstance}from 'vue'
export default {
  name: 'OpenScreen',
  props: {
            openScreenData: Object,//装修的数据
        },
  components: {

  },
  setup(props,{emit}) {
      const { proxy } = getCurrentInstance();
      const close_layer_icon=require('@/assets/coupon/close_layer_icon.png')
      const close=()=>{
          emit('closeScreen')
      }
      const diyNavTo=(val)=>{
                 proxy.$diyNavTo(val)
            }
      return{close_layer_icon,close,diyNavTo}
  }
}
</script>

<style lang="scss" scoped>
.sld_open_screen {
  position: absolute;
  background: rgba(0,0,0,.4);
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  z-index: 1000;
  text-align: center;
  .image{
     position: absolute;
    top: 50%;
    left: 50%;
    width: 680px;
    height: 420px;
    transform: translate(-50%,-50%);
    img{
        max-width: 100%;
        max-height: 100%;
    }
  }
  .close{
    position: absolute;
    width: 36px;
    height: 36px;
    top: 40px;
    right: 40px;
    z-index: 2;
    cursor: pointer;
  }
}
</style>
